// removed by extract-text-webpack-plugin
module.exports = {"message":"style__message___qoeGp","message--error":"style__message--error___2xDtR","message--success":"style__message--success___2KbMX","message__icon":"style__message__icon___HlJJ2","message__contents":"style__message__contents___3KBMi"};


//////////////////
// WEBPACK FOOTER
// ./components/GlobalMessage/style.scss
// module id = 1197
// module chunks = 0